import FlowStepService from 'src/modules/flowStep/flowStepService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'FLOWSTEP_FORM';

const flowStepFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: flowStepFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await FlowStepService.find(id);
      }

      dispatch({
        type: flowStepFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: flowStepFormActions.INIT_ERROR,
      });

      getHistory().push('/flow-step');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: flowStepFormActions.CREATE_STARTED,
      });

      await FlowStepService.create(values);

      dispatch({
        type: flowStepFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.flowStep.create.success'),
      );

      getHistory().push('/flow-step');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: flowStepFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, _getState) => {
    try {
      dispatch({
        type: flowStepFormActions.UPDATE_STARTED,
      });

      await FlowStepService.update(id, values);

      dispatch({
        type: flowStepFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.flowStep.update.success'),
      );

      getHistory().push('/flow-step');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: flowStepFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default flowStepFormActions;
